import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SimpleSkeleton = ({ h }) => {
    return (
        <>
            <Skeleton height={h} className="mb-24 " />
        </>
    );
};

export default SimpleSkeleton;
